<div id="area-temporaria">
	<div>
		<ng-container #container></ng-container>
	</div>
</div>
